<div class="modal-wrapper">
  <div class="modal-header">
    <div class="header-btns-left">
      <button
        (click)="openPhotoComment()"
        class="header-btn"
        mat-stroked-button
        color="secondary"
      >
        <mat-icon>comment</mat-icon>
      </button>
      <button
        class="header-btn"
        (click)="rotate(90)"
        mat-stroked-button
        color="secondary"
      >
        <mat-icon>rotate_90_degrees_cw</mat-icon>
      </button>
      <button mat-stroked-button class="header-btn invisibleBlock"></button>
    </div>
    <div class="header-btns-middle">
      <button
        [disabled]="fixedIndex || selectedPhotoIndex <= 0 || blockForLoading"
        class="header-btn"
        mat-stroked-button
        color="secondary"
        (click)="swipeImage(-1)"
      >
        <mat-icon>arrow_left</mat-icon>
      </button>
      <p class="indexCounter" *ngIf="!fixedIndex; else fixedIndexCounter">
        {{ selectedPhotoIndex + 1 }}/{{ photos.length }}
      </p>
      <ng-template #fixedIndexCounter>
        <p class="indexCounter">1/1</p>
      </ng-template>
      <button
        [disabled]="
          fixedIndex ||
          selectedPhotoIndex + 1 >= photos.length ||
          blockForLoading
        "
        class="header-btn"
        mat-stroked-button
        color="secondary"
        (click)="swipeImage(1)"
      >
        <mat-icon>arrow_right</mat-icon>
      </button>
    </div>
    <div class="header-btns-right">
      <button
        class="header-btn"
        (click)="deleteAllObjectsFromCanvas()"
        mat-stroked-button
        color="secondary"
      >
        <mat-icon class="material-icons-outlined">layers_clear</mat-icon>
      </button>
      <button
        (click)="deletePhoto()"
        class="header-btn"
        mat-stroked-button
        color="warn"
      >
        <mat-icon class="material-icons-outlined">delete</mat-icon>
      </button>
      <button
        (click)="close()"
        mat-stroked-button
        class="header-btn"
        color="secondary"
      >
        <mat-icon class="material-icons-outlined">cancel</mat-icon>
      </button>
    </div>
  </div>

  <div class="modal-body">
    <div class="comment-area" *ngIf="onPC && commentOpen">
      <textarea
        rows="2"
        cols="10"
        (click)="clearActiveObject()"
        (change)="updateRemarks($event.target.value)"
        [value]="photoRemarks"
        placeholder="add a comment..."
      ></textarea>
    </div>
    <div id="canvas-container" class="drawing-photo modal-body-content">
      <div class="canvas-holder-container">
        <div #canvasHolder class="canvas-holder center-block"></div>
      </div>
    </div>
  </div>
</div>
<!-- FOOTER -->

<div class="modal-body-master-bottom-actions">
  <div ngbDropdown>
    <button
      mat-stroked-button
      class="header-btn"
      color="secondary"
      (click)="toggleTopAction(TopActionsEnum.Selector)"
      (click)="togglePhotoTab(null, null)"
      [ngClass]="{
        'btn-active': topActions == TopActionsEnum.Selector
      }"
    >
      <mat-icon>touch_app</mat-icon>
    </button>
  </div>

  <div ngbDropdown placement="top-end" #buildDrop="ngbDropdown">
    <button
      mat-stroked-button
      class="header-btn"
      color="secondary"
      (click)="toggleTopAction(TopActionsEnum.Toolbox)"
      id="dropdownBuild"
      ngbDropdownToggle
      [ngClass]="{
        'btn-active': topActions == TopActionsEnum.Toolbox
      }"
    >
      <mat-icon>handyman</mat-icon>
    </button>
    <div
      ngbDropdownMenu
      aria-labelledby="dropdownBuild"
      class="dropdown-menu-lineStroke"
    >
      <button
        *ngIf="
          toggledPhotoTabId != 6 ||
          (toggledPhotoTabId == 6 && lineAddArrowHeads == 0)
        "
        mat-stroked-button
        color="secondary"
        class="menu-btn"
        (click)="buildDrop.close()"
        (click)="togglePhotoTab(6, null)"
        (click)="toggleBottomAction(BottomActionsEnum.Arrow)"
        (click)="setArrowHead(0)"
        [ngClass]="{
          'btn-active': toggledPhotoTabId == 6 && lineAddArrowHeads == 0
        }"
      >
        <mat-icon>horizontal_rule</mat-icon>
      </button>
      <button
        *ngIf="toggledPhotoTabId == 6 && lineAddArrowHeads != 0"
        mat-stroked-button
        color="secondary"
        class="menu-btn"
        (click)="buildDrop.close()"
        (click)="setArrowHead(0)"
        [ngClass]="{
          'btn-active': toggledPhotoTabId == 6 && lineAddArrowHeads == 0
        }"
      >
        <mat-icon>horizontal_rule</mat-icon>
      </button>
      <button
        *ngIf="
          toggledPhotoTabId != 6 ||
          (toggledPhotoTabId == 6 && lineAddArrowHeads != 0)
        "
        mat-stroked-button
        color="secondary"
        class="menu-btn"
        (click)="buildDrop.close()"
        (click)="togglePhotoTab(6, null)"
        (click)="toggleBottomAction(BottomActionsEnum.Arrow)"
        (click)="setArrowHead(2)"
        [ngClass]="{
          'btn-active': toggledPhotoTabId == 6 && lineAddArrowHeads != 0
        }"
      >
        <mat-icon>east</mat-icon>
      </button>
      <button
        *ngIf="toggledPhotoTabId == 6 && lineAddArrowHeads == 0"
        mat-stroked-button
        color="secondary"
        class="menu-btn"
        (click)="buildDrop.close()"
        (click)="setArrowHead(2)"
        [ngClass]="{
          'btn-active': toggledPhotoTabId == 6 && lineAddArrowHeads != 0
        }"
      >
        <mat-icon>east</mat-icon>
      </button>
      <button
        mat-stroked-button
        color="secondary"
        (click)="buildDrop.close()"
        (click)="togglePhotoTab(3, null)"
        (click)="toggleBottomAction(BottomActionsEnum.Icon)"
        (click)="toggleSubAction(SubActionsEnum.Icon)"
        class="menu-btn"
        [ngClass]="{ 'btn-active': toggledPhotoTabId == 3 }"
      >
        <mat-icon>lightbulb</mat-icon>
      </button>
      <button
        mat-stroked-button
        color="secondary"
        (click)="buildDrop.close()"
        (click)="togglePhotoTab(7, null)"
        (click)="toggleBottomAction(BottomActionsEnum.Circle)"
        class="menu-btn"
        [ngClass]="{ 'action-btn-active': toggledPhotoTabId == 7 }"
      >
        <mat-icon class="material-icons-outlined">circle</mat-icon>
      </button>
      <button
        mat-stroked-button
        color="secondary"
        (click)="buildDrop.close()"
        (click)="openTextBoxCreate()"
        (click)="togglePhotoTab(5, null)"
        (click)="toggleBottomAction(BottomActionsEnum.Text)"
        class="menu-btn"
        [ngClass]="{ 'btn-active': toggledPhotoTabId == 5 }"
      >
        <mat-icon>text_format</mat-icon>
      </button>
      <button
        mat-stroked-button
        color="secondary"
        (click)="buildDrop.close()"
        (click)="toggleBottomAction(BottomActionsEnum.DrawLine)"
        (click)="togglePhotoTab(1, null)"
        class="menu-btn"
        [ngClass]="{ 'btn-active': toggledPhotoTabId == 1 }"
      >
        <mat-icon>draw</mat-icon>
      </button>
    </div>
  </div>
  <ng-container
    *ngIf="
      bottomActions != BottomActionsEnum.Nothing &&
      topActions == TopActionsEnum.Selector
    "
  >
    <div ngbDropdown>
      <button
        (click)="removeSelectedObject()"
        class="header-btn"
        mat-stroked-button
        color="warn"
      >
        <mat-icon class="material-icons-outlined">delete</mat-icon>
      </button>
    </div>
    <div *ngIf="bottomActions != BottomActionsEnum.DrawLine" ngbDropdown>
      <button
        (click)="copySelectedObject()"
        class="header-btn"
        mat-stroked-button
        color="secondary"
      >
        <mat-icon>content_copy</mat-icon>
      </button>
    </div>
  </ng-container>
  <!-- BOTTOM ACTIONS -->
  <div
    class="modal-body-actions-bottom"
    *ngIf="
      bottomActions == BottomActionsEnum.DrawLine ||
      topActions == TopActionsEnum.DrawLine
    "
  >
    <div>
      <ng-container
        *ngTemplateOutlet="
          colorPalette;
          context: {
            colors: possibleLineColors,
            action: setLineColor.bind(this),
            selectedColor: selectedLineColor,
            icon: 'palette'
          }
        "
      ></ng-container>
    </div>
    <div>
      <ng-container
        *ngTemplateOutlet="
          strokeWidth;
          context: { action: setLineStrokeWidth.bind(this) }
        "
      ></ng-container>
    </div>
    <div>
      <ng-container
        *ngTemplateOutlet="
          lineStyle;
          context: { action: setLineDashArray.bind(this) }
        "
      ></ng-container>
    </div>
  </div>
  <div
    class="modal-body-actions-bottom"
    *ngIf="bottomActions == BottomActionsEnum.Circle"
  >
    <div>
      <ng-container
        *ngTemplateOutlet="
          colorPalette;
          context: {
            colors: possibleLineColors,
            action: setArrowColor.bind(this),
            selectedColor: selectedLineColor,
            icon: 'palette'
          }
        "
      ></ng-container>
    </div>
    <div>
      <ng-container
        *ngTemplateOutlet="
          strokeWidth;
          context: { action: setArrowStrokeWidth.bind(this) }
        "
      ></ng-container>
    </div>
    <div>
      <ng-container
        *ngTemplateOutlet="
          lineStyle;
          context: { action: setArrowDashArray.bind(this) }
        "
      ></ng-container>
    </div>
  </div>

  <div
    class="modal-body-actions-bottom"
    *ngIf="bottomActions == BottomActionsEnum.Arrow"
  >
    <div>
      <ng-container
        *ngTemplateOutlet="
          colorPalette;
          context: {
            colors: possibleLineColors,
            action: setArrowColor.bind(this),
            selectedColor: selectedLineColor,
            icon: 'palette'
          }
        "
      ></ng-container>
    </div>
    <div>
      <ng-container
        *ngTemplateOutlet="
          strokeWidth;
          context: { action: setArrowStrokeWidth.bind(this) }
        "
      ></ng-container>
    </div>
    <div>
      <div ngbDropdown placement="top-end" #lineArrowhead="ngbDropdown">
        <button
          (click)="toggleSubAction(SubActionsEnum.Nothing)"
          mat-stroked-button
          class="header-btn"
          color="secondary"
          id="dropdownBasic2"
          ngbDropdownToggle
          [ngSwitch]="lineAddArrowHeads"
        >
          <mat-icon *ngSwitchCase="3">sync_alt</mat-icon>
          <mat-icon *ngSwitchCase="2">east</mat-icon>
          <mat-icon *ngSwitchCase="1">west</mat-icon>
          <mat-icon *ngSwitchCase="0">horizontal_rule</mat-icon>
        </button>
        <div
          ngbDropdownMenu
          aria-labelledby="dropdownBasic2"
          class="dropdown-menu-lineStroke"
        >
          <button
            (click)="lineArrowhead.close()"
            (click)="setArrowHead(0)"
            class="menu-btn"
            mat-stroked-button
            color="secondary"
          >
            <mat-icon>horizontal_rule</mat-icon>
          </button>
          <button
            (click)="lineArrowhead.close()"
            (click)="setArrowHead(1)"
            class="menu-btn"
            mat-stroked-button
            color="secondary"
          >
            <mat-icon>west</mat-icon>
          </button>
          <button
            (click)="lineArrowhead.close()"
            (click)="setArrowHead(2)"
            class="menu-btn"
            mat-stroked-button
            color="secondary"
          >
            <mat-icon>east</mat-icon>
          </button>
          <button
            (click)="lineArrowhead.close()"
            (click)="setArrowHead(3)"
            class="menu-btn"
            mat-stroked-button
            color="secondary"
          >
            <mat-icon>sync_alt</mat-icon>
          </button>
        </div>
      </div>
    </div>
    <div>
      <ng-container
        *ngTemplateOutlet="
          lineStyle;
          context: { action: setArrowDashArray.bind(this) }
        "
      ></ng-container>
    </div>
  </div>

  <div
    class="modal-body-actions-bottom"
    *ngIf="bottomActions == BottomActionsEnum.Text"
  >
    <div>
      <button
        class="header-btn"
        mat-stroked-button
        color="secondary"
        (click)="openTextBoxCreate()"
      >
        <mat-icon>text_format</mat-icon>
      </button>
    </div>
    <ng-container
      *ngTemplateOutlet="
        colorPalette;
        context: {
          colors: possibleTextColors,
          action: setTextColor.bind(this),
          selectedColor: selectedTextColor,
          icon: 'palette'
        }
      "
    ></ng-container>
    <ng-container
      *ngTemplateOutlet="
        colorPalette;
        context: {
          colors: possibleBackgroundColors,
          action: setTextBackgroundColor.bind(this),
          selectedColor: '#000000',
          icon: 'wallpaper'
        }
      "
    ></ng-container>
    <ng-container
      *ngTemplateOutlet="
        colorPalette;
        context: {
          colors: possibleBorderColors,
          action: setTextBorderColor.bind(this),
          selectedColor: '#000000',
          icon: 'border_outer'
        }
      "
    ></ng-container>
  </div>
  <div
    class="modal-body-actions-bottom"
    *ngIf="bottomActions == BottomActionsEnum.Icon"
  >
    <ng-container
      *ngTemplateOutlet="
        colorPalette;
        context: {
          colors: possibleBackgroundColors,
          action: setTextBackgroundColor.bind(this),
          selectedColor: '#000000',
          icon: 'wallpaper'
        }
      "
    ></ng-container>
  </div>
</div>
<ng-template
  #colorPalette
  let-colors="colors"
  let-fn="action"
  let-selectedColor="selectedColor"
  let-icon="icon"
>
  <div ngbDropdown placement="top-end" #colorPalette="ngbDropdown">
    <button
      (click)="toggleSubAction(SubActionsEnum.Nothing)"
      mat-stroked-button
      class="header-btn"
      color="secondary"
      id="dropdownBasic2"
      ngbDropdownToggle
    >
      <mat-icon [ngStyle]="{ color: selectedColor }">{{ icon }}</mat-icon>
    </button>
    <div
      ngbDropdownMenu
      aria-labelledby="dropdownBasic2"
      class="dropdown-menu-lineStroke"
    >
      <button
        *ngFor="let color of colors"
        (click)="colorPalette.close()"
        (click)="fn(color)"
        class="menu-btn"
        mat-stroked-button
        [ngStyle]="{ 'background-color': color == transparent ? white : color }"
      >
        <mat-icon *ngIf="color == transparent" [ngStyle]="{ color: black }"
          >block</mat-icon
        >
      </button>
    </div>
  </div>
</ng-template>
<ng-template #strokeWidth let-fn="action">
  <div ngbDropdown placement="top-end" #lineStrokeDrop="ngbDropdown">
    <button
      (click)="toggleSubAction(SubActionsEnum.Nothing)"
      mat-stroked-button
      class="header-btn"
      color="secondary"
      id="dropdownBasic2"
      ngbDropdownToggle
    >
      {{ selectedLineStrokeWidth }}px
    </button>
    <div
      ngbDropdownMenu
      aria-labelledby="dropdownBasic2"
      class="dropdown-menu-lineStroke"
    >
      <button
        *ngFor="let width of possibleStrokeWidths"
        (click)="fn(width)"
        (click)="lineStrokeDrop.close()"
        class="menu-btn"
        color="secondary"
        mat-stroked-button
        [ngClass]="{
          'btn-active': selectedLineStrokeWidth == width
        }"
      >
        {{ width }}px
      </button>
    </div>
  </div>
</ng-template>
<ng-template #lineStyle let-fn="action">
  <div ngbDropdown placement="top-end" #lineDashArray="ngbDropdown">
    <button
      (click)="toggleSubAction(SubActionsEnum.Nothing)"
      mat-stroked-button
      class="header-btn"
      color="secondary"
      id="dropdownBasic2"
      ngbDropdownToggle
    >
      <mat-icon>line_style</mat-icon>
    </button>
    <div
      ngbDropdownMenu
      aria-labelledby="dropdownBasic2"
      class="dropdown-menu-lineStroke"
    >
      <button
        (click)="lineDashArray.close()"
        (click)="fn([0, 0])"
        class="menu-btn"
        mat-stroked-button
        color="secondary"
      >
        <mat-icon>horizontal_rule</mat-icon>
      </button>
      <button
        (click)="lineDashArray.close()"
        (click)="fn([20, 5])"
        class="menu-btn stroke-dash-big"
        mat-stroked-button
        color="secondary"
      >
        --
      </button>
      <button
        (click)="lineDashArray.close()"
        (click)="fn([10, 5])"
        class="menu-btn stroke-dash-medium"
        mat-stroked-button
        color="secondary"
      >
        ---
      </button>
      <button
        (click)="lineDashArray.close()"
        (click)="fn([5, 5])"
        class="menu-btn stroke-dash-small"
        mat-stroked-button
        color="secondary"
      >
        ----
      </button>
    </div>
  </div>
</ng-template>
<!-- BOTTOM ACTIONS -->

<!-- SUB ACTIONS -->
<div
  class="modal-body-actions"
  *ngIf="
    bottomActions == BottomActionsEnum.Icon &&
    topActions != TopActionsEnum.Selector
  "
>
  <div class="arrow-photo" *ngFor="let id of tags">
    <span class="helper"></span>
    <img
      src="{{ imageBaseUrl + 'Tag_' + tagEnum[id] + '.svg' }}"
      (click)="addImage(tagEnum[id], id, 3)"
    />
  </div>
</div>
